import React from 'react'
import PropTypes from 'prop-types'
import { Input, InputGroupText, InputGroupAddon, Spinner } from 'reactstrap'

const InputWithLoader = React.forwardRef(({ loading = false, disabled, ...props}, ref) => {
  return (
    <>
       <Input 
          {...props}
          innerRef={ref}
          disabled={disabled || loading}
        />
      { loading && 
          <InputGroupAddon addonType="append">
              <InputGroupText>
                  <Spinner 
                      type="border" 
                      color="secondary" 
                      role="status"
                      style={{borderWidth: "1.5px", width: "1rem", height: "1rem"}}
                  />
              </InputGroupText>
          </InputGroupAddon> 
      }
    </>
  )
})

InputWithLoader.propTypes = {
  
}

export default InputWithLoader

